export default __webpack_public_path__ + "media/images/banners/bnr_toba-53eb55caec1034bcd76394512a0a24ca.png";